/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsSuspendAliases {
  CONTENT_PANEL = 'content-panel',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  REASON_AUTOCOMPLETE = 'reason-autocomplete',
  REASON_FETCH = 'reason-fetch',
  REASON_FIELD = 'reason-field',
  REASON_MAPPER = 'reason-mapper',
  REASON_TEXT = 'reason-text',
  RESERVED_BLOOD_PRODUCTS_SUSPEND_FORM = 'reserved-blood-products-suspend-form',
  RESERVED_BLOOD_PRODUCTS_SUSPEND_LAYOUT = 'reserved-blood-products-suspend-layout',
  SCHEDULE_DATE_FIELD = 'schedule-date-field',
  SCHEDULE_DATE_INPUT = 'schedule-date-input',
  TITLE_FIELD = 'title-field',
  TITLE_PANEL = 'title-panel',
  TITLE_TEXT = 'title-text',
}
export { ReservedBloodProductsSuspendAliases };
